import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import api from '../api';
import './Login.css';   // reuse the same styles

function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const userId = searchParams.get('userId');
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [walletAddress, setWalletAddress] = useState('');

  if (!userId) {
    return (
      <div className="login-page">
        <div className="login-container">
          <div className="login-form-panel">
            <h2>Invalid Link</h2>
            <p>Missing user information. Please sign up again.</p>
            <Link to="/signup">Go to Signup</Link>
          </div>
        </div>
      </div>
    );
  }

  const handleVerify = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const res = await api.post('/api/auth/verify-email', { userId, code });
      // Success – store token and user, then show wallet
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('user', JSON.stringify(res.data.user));
      setWalletAddress(res.data.user.walletAddress);
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Verification failed');
    }
  };

  if (success) {
    return (
      <div className="login-page">
        <div className="login-bg-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
        </div>
        <div className="login-container">
          <div className="login-brand">
            <div className="brand-lock">🔐</div>
            <h1>Recovery Vault</h1>
            <p className="brand-tagline">Institutional‑grade security for your digital assets</p>
          </div>
          <div className="login-form-panel">
            <div className="success-box" style={{ textAlign: 'center' }}>
              <h3 style={{ color: '#10b981', marginBottom: '1rem' }}>✅ Email Verified!</h3>
              <p style={{ color: '#cbd5e1', marginBottom: '1rem' }}>Your wallet has been created.</p>
              <div className="wallet-display" style={{
                background: 'rgba(255,255,255,0.08)',
                borderRadius: '0.75rem',
                padding: '1rem',
                wordBreak: 'break-all',
                marginBottom: '1rem',
                fontFamily: 'monospace'
              }}>
                <code style={{ color: '#f1f5f9' }}>{walletAddress}</code>
              </div>
              <p style={{ color: '#94a3b8', fontSize: '0.9rem' }}>Copy this address – you'll need it to receive assets.</p>
              <Link to="/login">
                <button style={{
                  marginTop: '1.5rem', width: '100%', padding: '0.85rem',
                  background: 'linear-gradient(135deg, #3b82f6, #2563eb)', color: 'white',
                  border: 'none', borderRadius: '0.75rem', fontWeight: 600, fontSize: '1rem', cursor: 'pointer'
                }}>
                  Go to Login
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="login-bg-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
      </div>
      <div className="login-container">
        <div className="login-brand">
          <div className="brand-lock">🔐</div>
          <h1>Recovery Vault</h1>
          <p className="brand-tagline">Institutional‑grade security for your digital assets</p>
        </div>
        <div className="login-form-panel">
          <div className="form-header">
            <h2>Verify Your Email</h2>
            <p>We sent a 6‑digit code to your email address</p>
          </div>
          {error && <div className="login-error">{error}</div>}
          <form onSubmit={handleVerify} className="login-form">
            <div className="input-group">
              <span className="input-icon">🔢</span>
              <input
                type="text"
                placeholder="6‑digit code"
                value={code}
                onChange={e => setCode(e.target.value)}
                required
                maxLength={6}
              />
            </div>
            <button type="submit" className="login-btn">
              <span>Verify</span>
              <span className="btn-arrow">→</span>
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default VerifyEmail;
